<template>
  <div class="footer tabbar row" style="z-index: 5">
    
    
    <a :class="['cc', {'active': homeActive}]" @click="toHome">
      <i class="iconfont icon-1"></i>
      <span>漫画</span>
    </a>

    <a :class="['cc', {'active': categoryActive}]" @click="toCategory">
      <i class="iconfont icon-2"></i>
      <span>分类</span>
    </a>
    
    
    <a :class="['cc', {'active': vodActive},'c-a']" @click="toVod">
      <i class="iconfont icon-1"></i>
      <span>看视频</span>
    </a>

   <!-- <a :class="['cc', {'active': newActive}]" @click="toNew">
     <i class="iconfont icon-5"></i>
     <span>更新</span>
    </a> -->
    <a :class="['cc', {'active': shelfActive}]" @click="toHistory">
      <i class="iconfont icon-3"></i>
      <span>收藏</span>
    </a>
    <a :class="['cc', {'active': userActive}]" @click="toMine">
      <i class="iconfont icon-4"></i>
      <span>我的</span>
    </a>
  </div>
</template>

<script>

  export default {
    name: "layer1",
    computed: {
      homeActive() {
        return this.$route.name === 'home'
      },
      categoryActive() {
        return this.$route.path === '/category'
      },
      vodActive() {
        return this.$route.path === '/vod'
      },
      newActive() {
        return this.$route.path === '/new'
      },
      shelfActive() {
        return this.$route.path === '/shelf'
      },
      userActive() {
        return this.$route.path === '/user'
      }
    },
    methods: {
      toHome() {
        if (this.$route.name === 'home') return;
        this.$router.isBack = false;
        this.$router.push('/home')
        // this.$emit('page-change', 'home')
      },
      toCategory() {
        if (this.$route.name === 'category') return;
        this.$router.isBack = false;
        this.$router.push('/category')
        // this.$emit('page-change', 'category')
      },
      toVod() {
        if (this.$route.name === 'vod') return;
        this.$router.isBack = false;
        this.$router.push('/vod')
        // this.$emit('page-change', 'vod')
      },
      toNew() {
        if (this.$route.name === 'new') return;
        this.$router.isBack = false;
        this.$router.push('/home/new')
      },
      toHistory() {
        if (this.$route.name === 'shelf') return;
        this.$router.isBack = false;
        this.$router.push('/shelf')
        // this.$emit('page-change', 'shelf')
      },
      toMine() {
        if (this.$route.name === 'user') return;
        this.$router.isBack = false;
        this.$router.push('/user')
        // this.$emit('page-change', 'user')
      }
    }
  }
</script>

<style scoped>
  /*
  a.active {
    background-color: #f0f0f0;
  }
  a.active span {
    color: #000000;
  }
   */
</style>



// WEBPACK FOOTER //
// src/components/layer1/bottom.vue